module.exports = __webpack_public_path__ + "img/NC_Logo.89efc526.svg";